var _g, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 142,
    viewBox: "0 0 145 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_454_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0709 86.4258C100.18 81.9609 102 76.5489 102 70.7161C102 55.4089 89.464 43 74 43C58.536 43 46 55.4089 46 70.7161C46 86.0232 58.536 98.4321 74 98.4321C79.4729 98.4321 84.5791 96.8778 88.8927 94.1909L100.106 99.0023L97.0709 86.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0709 86.4258L96.6606 86.1401L96.5321 86.3246L96.5848 86.5431L97.0709 86.4258ZM88.8927 94.1909L89.0898 93.7314L88.8499 93.6284L88.6283 93.7665L88.8927 94.1909ZM100.106 99.0023L99.9086 99.4617L100.826 99.8554L100.592 98.885L100.106 99.0023ZM101.5 70.7161C101.5 76.4431 99.7131 81.756 96.6606 86.1401L97.4812 86.7115C100.646 82.1657 102.5 76.6546 102.5 70.7161H101.5ZM74 43.5C89.1926 43.5 101.5 55.6898 101.5 70.7161H102.5C102.5 55.128 89.7353 42.5 74 42.5V43.5ZM46.5 70.7161C46.5 55.6898 58.8074 43.5 74 43.5V42.5C58.2647 42.5 45.5 55.128 45.5 70.7161H46.5ZM74 97.9321C58.8074 97.9321 46.5 85.7423 46.5 70.7161H45.5C45.5 86.3042 58.2647 98.9321 74 98.9321V97.9321ZM88.6283 93.7665C84.392 96.4053 79.3771 97.9321 74 97.9321V98.9321C79.5688 98.9321 84.7663 97.3504 89.157 94.6153L88.6283 93.7665ZM100.303 98.5428L89.0898 93.7314L88.6955 94.6504L99.9086 99.4617L100.303 98.5428ZM96.5848 86.5431L99.6197 99.1195L100.592 98.885L97.5569 86.3085L96.5848 86.5431Z",
    fill: "#F0EFFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_454_3200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 59,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 59.001,
    width: 24,
    height: 24,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_454_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.96 73.6412V66.2012H64.4C63.08 66.2012 62 67.2812 62 68.6012V75.8012C62 77.1212 63.08 78.2012 64.4 78.2012H65.6V81.8012L69.2 78.2012H75.2C76.52 78.2012 77.6 77.1212 77.6 75.8012V73.6172C77.5232 73.634 77.4416 73.6424 77.36 73.6424H68.96V73.6412ZM83.6 60.2012H72.8C71.48 60.2012 70.4 61.2812 70.4 62.6012V72.2012H78.8L82.4 75.8012V72.2012H83.6C84.92 72.2012 86 71.1224 86 69.8012V62.6012C86 61.2812 84.92 60.2012 83.6 60.2012Z",
    fill: "url(#paint0_linear_454_3200)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_454_3200",
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147.355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.027451 0 0 0 0 0.298039 0 0 0 0.0784314 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_454_3200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_454_3200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_3200",
    x1: 50,
    y1: 71.0012,
    x2: 71.4806,
    y2: 94.8686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551645,
    stopColor: "#625DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A44ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountChat);
export default __webpack_public_path__ + "static/media/accountChat.5d05bb18697c8821a9519f63394ac936.svg";
export { ForwardRef as ReactComponent };